import React from 'react';

/**
 * Convert ISO 3166-1 alpha-2 country code to Twemoji hex code
 * Example: "US" -> "1f1fa-1f1f8"
 */
export function isoToTwemojiHex(code: string): string {
  const REGIONAL_INDICATOR_A = 0x1F1E6;
  const codeUpper = code.toUpperCase();
  const first = REGIONAL_INDICATOR_A + (codeUpper.charCodeAt(0) - 65);
  const second = REGIONAL_INDICATOR_A + (codeUpper.charCodeAt(1) - 65);
  return `${first.toString(16)}-${second.toString(16)}`;
}

/**
 * Get Twemoji SVG URL for a country code
 */
export function getFlagSvgUrl(code: string): string {
  return `https://cdnjs.cloudflare.com/ajax/libs/twemoji/14.0.2/svg/${isoToTwemojiHex(code)}.svg`;
}

/**
 * Flag component that renders country flag as SVG image
 */
export const Flag: React.FC<{ 
  code: string; 
  size?: number; 
  className?: string;
}> = ({ code, size = 20, className = '' }) => {
  const [error, setError] = React.useState(false);

  if (error) {
    return <span className={`text-xs ${className}`}>{code}</span>;
  }

  return (
    <img
      loading="lazy"
      width={size}
      height={size}
      src={getFlagSvgUrl(code)}
      alt={`${code} flag`}
      className={`inline-block align-middle ${className}`}
      style={{ borderRadius: 4 }}
      onError={() => setError(true)}
    />
  );
};
